
import React, { useEffect, useState } from 'react'
import CollectionViewer from '../../components/collection-viewer'
import Layout from '../../components/layout'

const SellingOut = (props) => {
  const [updated, setUpdated] = useState(0)
  let refresh = 5
  if(props.location.state) refresh = props.location.state.refresh
  useEffect(() => {
    setUpdated(prev => prev + 1)
  }, [refresh])
  return(
    <Layout location={props.location}>
      <CollectionViewer collectionId={5} shouldRefresh={updated} />
    </Layout>
  )
}

export default SellingOut